<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">供应商名称</div>
          <div class="field">
            <el-input v-model.trim="query.comfullname" clearable></el-input>
          </div>
        </div>
         <div class="searchItem">
            <div class="label">业务员</div>
            <div class="field">
              <el-input v-model.trim="query.ptcname" clearable></el-input>
            </div>
        </div>
         <div class="searchItem">
          <div class="label">采购人</div>
          <div class="field">
            <el-input v-model.trim="query.pcomfullname" clearable></el-input>
          </div>
        </div>
        <!-- <div class="searchItem">
          <div class="label">支付方式</div>
          <div class="field">
            <el-select v-model="query.paytype" :clearable="true" placeholder="请选择">
              <el-option
                v-for="item in paytypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div> -->
        <div class="searchItem">
          <div class="label">是否收款</div>
          <div class="field">
            <el-select v-model="query.ishaspay" :clearable="true" placeholder="请选择">
              <el-option v-for="item in payList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">开票状态</div>
          <div class="field">
            <el-select v-model="query.fpflg" :clearable="true" placeholder="请选择">
              <el-option v-for="item in fpList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- <div class="searchItem">
          <div class="label">平台编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectno" clearable></el-input>
          </div>
        </div> -->
        <div class="searchItem">
          <div class="label">时间</div>
          <div class="field" style="width: 400px">
            <el-date-picker v-model="query.begTime" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
            <div style="margin: 0 10px">至</div>
            <el-date-picker v-model="query.endTime" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type="primary" @click="search">查询</el-button>
            <el-button v-if="+query.comtype === 1" type="primary" @click="showButton = !showButton">{{ showButton ? "收起"
              : "展开"
            }}</el-button>
          </div>
        </div>
      </div>
      <div>
        <el-collapse-transition v-if="+query.comtype === 1">
          <div v-show="showButton" style="padding: 10px">
            <el-radio-group v-model="areaid" @change="getPageList">
              <el-radio-button v-for="item in this.areaList" :key="item.dptareacode" :label="item.dptareacode">{{
                item.label
              }}</el-radio-button>
            </el-radio-group>
          </div>
        </el-collapse-transition>
      </div>
    </div>

    <vggrid :list="list" tableheight="600" flexname="" :cols="cols" :showfooter="false" :showPage="true" :resizable="true"
      :defaultPage="10" :loading="loading"  :total="query.total" @cellDblClick="viewProject" @cellClick="cellClick" @pagechange="pagechange"
      :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick">
      <template slot="btn">
        <div style="display: flex">
          <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
          <div>【服务费合计】:{{ amt.fwf_sum | Thousands }} 元</div>
        </div>
      </template>
    </vggrid>
  </Container>
</template>
<script>
import request from "@/utils/request";
import MenuBtn from "../common/menuBtn";
import vggrid from "../common/vggrid";
import dayjs from "dayjs";
import utils from "../../assets/js/utils";

export default {
  name: "psuFwfconIndex",
  data() {
    return {
      menuid: this.$route.query.menuid,
      list: [],
      areaList: [],
      areaid: 0,
      amt: {},
      btn: {},
      btnLoading: false,
      showButton: true,
      cols: [
        {
          type: "index",
          fieldtype: "I",
          title: "行号",
          calculExpr: "",
          width: 50,
        },
        {
          field: "projectcode",
          fieldtype: "C",
          title: "项目编号",
          calculExpr: "",
          addNewRowFlg: false,
        },
        // { field: 'projectno', fieldtype: 'C', title: '平台编号',calculExpr:'',addNewRowFlg: false, width: 150},
        {
          field: "projectname",
          fieldtype: "C",
          title: "项目名称",
          calculExpr: "",
          addNewRowFlg: false,
          width: 200,
        },
        {
          field: "comfullname",
          fieldtype: "C",
          title: "供应商",
          calculExpr: "",
          addNewRowFlg: false,
        },
         {
          field: "ptcusername",
          fieldtype: "I",
          title: "业务员",
          calculExpr: "",
        },
        {
          field: "projectcomfullname",
          fieldtype: "C",
          title: "采购人",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psuconfirmfeeamtCN",
          fieldtype: "C",
          title: "服务费",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psufeepayusername",
          fieldtype: "C",
          title: "支付人",
          calculExpr: "",
          addNewRowFlg: false,
        },
        // { field: 'psubmpaytypedesc', fieldtype: 'C', title: '支付方式',calculExpr:'',addNewRowFlg: false},
        {
          field: "psufeepaytime",
          fieldtype: "C",
          title: "支付时间",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psufeepayCN",
          fieldtype: "C",
          title: "支付状态",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psufewreceivetime",
          fieldtype: "C",
          title: "收款时间",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psufwfinvoiceflgname",
          fieldtype: "C",
          title: "发票",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          title: "操作 ",
          width: 130,
          showOverflow: true,
          slots: {
            default: ({ row }) => {
              if (+row.psufewreceive === 1 && +row.psufwfinvoiceflg === 2) {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.goPsuFwfFrom.bind(this, row)}
                  >
                    查看
                  </vxe-button>,
                ];
              } else if (+row.psufewreceive != 1) {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.goPsuFwfFrom.bind(this, row)}
                  >
                    收款
                  </vxe-button>,
                ];
              } else {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.goPsuFwfFrom.bind(this, row)}
                  >
                    登记发票
                  </vxe-button>,
                ];
              }
            },
          },
        },
      ],
      psu: {},
      query: {
        comid: this.$store.getters.loginUser.comid,
        comtype: this.$store.getters.loginUser.comtype,
        userid: this.$store.getters.loginUser.userid,
        total: 0,
        limit: 10,
        offset: 0,
      },
      paytypeList: [
        { label: "支付宝支付", value: "1" },
        { label: "微信支付", value: "2" },
        { label: "线下支付", value: "3" },
      ],
      fpList: [
        { label: "未开", value: "1" },
        { label: "已开", value: "2" },
      ],
      payList: [
        { label: "已收", value: "1" },
        { label: "未收", value: "2" },
      ],
      projectStatusList: [],
      loading: false
    };
  },
  created() {
    this.$on("QRFWF", () => this.QRFwfcon());
    this.$on("CLOSE", () => this.close());
  },
  activated() {
    this.init();
    this.getPageList();
    this.getProjectStatusList();
    if (this.query.comtype === 1) {
      this.getareaList();
    }
  },
  filters: {
    Thousands(val) {
      return val ? utils.comdify(val) : 0;
    },
  },
  mounted() { },
  watch: {},
  components: { MenuBtn, vggrid },
  methods: {
    btnClick(code) {
      this.$emit(code);
    },
    vggridClick(code, row) {
      this.psu = row;
      this.$emit(code, row);
    },
    btnmenuclick(btn) {
      this.btn = btn;
    },
    async init() {
      // this.query = {
      //   comid: this.$store.getters.loginUser.comid,
      //   limit: 20,
      //   offset: 0
      // }
      this.list = [];
      this.btnLoading = false;
      this.psu = {};
    },
    async getProjectStatusList() {
      this.projectStatusList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "psubzjreturnflg" },
      });
    },
    //获取地区list
    async getareaList() {
      let res = await request({
        method: "get",
        url: "/xtgl/dpt/getDptareaList",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });
      this.areaList = res.filter((e) => {
        return +e.dptareause === 1;
      });
      this.areaList.unshift({
        dptareacode: 0,
        label: "全部",
      });
    },
    async QRFwfcon() {
      if (!this.psu.psuid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      this.$router.push({
        name: "psuFwfconForm",
        params: { form: this.psu, type: 1 },
      });
    },
    async close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "",
      });
    },
    async cellClick(row) {
      this.psu = row.row;
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1);
      this.query.limit = page.pageSize;
      this.getPageList();
    },
    search() {
      this.query.offset = 0;
      if (this.query.endTime) {
        this.query.endtime = dayjs(this.query.endTime)
          .add(1, "day")
          .format("YYYY-MM-D");
      }
      this.getPageList();
    },
    async getFwfSum() { },
    async getPageList() {
      this.loading = true;
      this.query.cosid = this.$store.getters.loginUser.cosid;
      this.query.areaid = this.areaid;
      this.query.selectField = `projectcode,projectptccode,projectname,projecttime,psufwfinvoicenum,
        projectid,projectstatus,projectisinvite,projectisqcheck,com.comfullname as comfullname,pcom.comfullname, psuid,psufeeamt,
        psufeepaytime,psufewreceivetime,psufwfinvoiceflg,psuconfirmfeeuserid,psuconfirmfeeamt,psufeepaytype,psufewreceive`;
      let res = await request({
        method: "get",
        url: "/cwgl/psuFwf/getFwffee",
        params: this.query,
      });

      res.list.forEach((key) => {
        key.psufeeamt = utils.comdify(key.psufeeamt);
        key.psufeepaytime = utils.formatterDate(
          key.psufeepaytime,
          "yyyy-MM-dd"
        );
        key.psufewreceivetime = utils.formatterDate(
          key.psufewreceivetime,
          "yyyy-MM-dd"
        );
        key.psufeepayusername = key.psufeepayusername
          ? key.psufeepayusername + " " + key.psufeepayuserphone
          : "";
        key.psufwfinvoiceflgname =
          +key.psufwfinvoiceflg === 1
            ? "未开"
            : +key.psufwfinvoiceflg === 2
              ? key.psufwfinvoicenum
              : "";
        key.psuconfirmfeeamtCN = key.psuconfirmfeeuserid
          ? utils.comdify(key.psuconfirmfeeamt)
          : "未确认";
        // if (key.psufeecheckuserid || key.psufeepayuserid)
        //   key.psufeepayCN = "已支付"
        // else
        //   key.psufeepayCN = "未支付"

        if (Number(key.psuconfirmfeeamt) > 0) {
          key.psufeepayCN = "未付";
          if (+key.psufeepaytype > 0 && +key.psufewreceive !== 2) {
            key.psufeepayCN = "待确认";
          }
          if (+key.psufewreceive === 1) {
            key.psufeepayCN = "已付";
          }
        }
        key.psufeeamtdesc = utils.comdify(key.psufeeamt);
        if (+key.psufeepaytype === 1 || +key.psufeepaytype === 2) {
          key.psufewreceivename = "线上支付";
        }
        key.psubmpaytypedesc =
          +key.psufeepaytype === 1
            ? "支付宝支付"
            : +key.psufeepaytype === 2
              ? "微信支付"
              : +key.psufeepaytype === 3
                ? "线下支付"
                : "";
      });
      this.list = res.list;
      this.amt = res.amt[0];
      this.query.total = res.count[0].count;
      this.loading = false;
    },
    async viewProject(row) {
      this.psu = row.row;
      this.$router.push({
        name: "psuFwfconForm",
        params: { form: this.psu, innerbtn: this.btn.inner, type: 3 },
      });
    },
    goPsuFwfFrom(row) {
      this.psu = row;
      this.$router.push({
        name: "psuFwfconForm",
        params: { form: this.psu, innerbtn: this.btn.inner, type: 3 },
      });
    },
  },
};
</script>
<style lang="scss">
</style>
